/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlockUserBody
 */
export interface BlockUserBody {
    /**
     * The user ID to block
     * @type {string}
     * @memberof BlockUserBody
     */
    userId: string;
    /**
     * Internal reason for blocking (not exposed to blocked user)
     * @type {string}
     * @memberof BlockUserBody
     */
    reason?: string;
}

/**
 * Check if a given object implements the BlockUserBody interface.
 */
export function instanceOfBlockUserBody(value: object): value is BlockUserBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function BlockUserBodyFromJSON(json: any): BlockUserBody {
    return BlockUserBodyFromJSONTyped(json, false);
}

export function BlockUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockUserBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function BlockUserBodyToJSON(json: any): BlockUserBody {
    return BlockUserBodyToJSONTyped(json, false);
}

export function BlockUserBodyToJSONTyped(value?: BlockUserBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'reason': value['reason'],
    };
}

